export default __webpack_public_path__ + "static/media/shelf.5d2558ea.png";